import useConstants from '@api/hooks/useConstants';
import useGeoLocation from '@api/hooks/useGeoLocation';
import { isEmailLoginCountry } from '@api/selectors/constants';

const useIsOutsideIndiaFlow = () => {
  const { geoLocationData: { countryCode } = {} } = useGeoLocation();
  return useConstants(isEmailLoginCountry(countryCode));
};

export default useIsOutsideIndiaFlow;
